<template>
    <div class="primary-button"
        ref="button"
        @click="onClick"
        :class="mainClass"
        :style="mainStyle"
        @mouseover="onOver"
        @mouseleave="onOut">
        <div class="primary-button-bg"/>
        <slot name="header"></slot>
        <slot>
            <span v-if="text">{{text}}</span>
            <i :class="icon" v-if="icon"/>
        </slot>
        <slot name="footer"></slot>
    </div>
</template>

<script>
export default {
  props: {
      text: {
          type: String,
          default: ''
      },
      icon: {
          type: String,
          default: ''
      },
      naked: {
          type: Boolean,
          default: false
      },
      enabled: {
          type: Boolean,
          default: true
      }
  },
  data() {
      return {
          scale: 1
      }
  },
  computed: {
      mainClass() {
          let a = []
          a.push(this.naked ? 'naked' : 'normal')
          if (!this.enabled) a.push('is-disabled')
          return a
      },
      mainStyle() {
          return {
              transform: 'scale(' + this.scale + ')'
          }
      },
      button() {
          return this.$refs.button
      }
  },
  methods: {
    onClick(e) {
        this.$emit('click', e)
    },
    onOver() {
        if (!this.enabled) return
        this.scale = 1 + (20 / this.button.offsetWidth) / Math.max(300 / this.button.offsetWidth, 1)
    },
    onOut() {
        this.scale = 1
    }
  }
}
</script>

<style lang="stylus">
@import "~assets/v3/css/variables.styl";

.primary-button
    position relative
    display flex
    align-items center
    justify-content space-between
    min-height 36px
    width fit-content
    padding 10px 16px
    font-size 16px
    font-weight 700
    border-radius 5px
    border 1px solid alpha(white, 40%)
    color $color-primary-text
    // overflow hidden
    background-color $color-primary

    > *
        z-index 1

    &+.primary-button:not(.no-sibling-margin)
        margin-left 8px

    .primary-button-bg
        position absolute
        top 0
        left 0
        width 100%
        height 100%
        z-index 0
        background-color white
        opacity 0

    i
        font-size 12px
        font-weight normal

    span+i
        margin-left 16px

    span+img
        margin-left 16px

    &.normal
        basic-button-v2(1.0, 0.5, ".primary-button-bg", 0, $bg-opacity: 0)
        box-shadow 0 0 0 -10px rgba(0, 0, 0, 0.2)

    &.naked
        basic-button-v2(1.0, 0, ".primary-button-bg", 0, $bg-opacity: 0)
        // box-shadow 0 0 0 -10px rgba(0, 0, 0, 0.2)

    &.big
        height 60px
        padding 0 30px
        color $color-primary-text
        // basic-button-v2(1.0, 0.5, ".primary-button-bg")

        i
            // font-size 18px
            font-size 12px
            font-weight normal

            &+*
                margin-right 16px

    &.small
        min-height 24px
        font-size 14px
        padding 5px 8px

        span+i
            margin-left 8px

    &.secondary
        color $color-secondary-text
        // border-color alpha($color-secondary, 40%)
        background-color $color-secondary

    &.tertiary
        color $color-tertiary-text
        border-color #DDDDDD
        background-color $color-tertiary

        &.naked:hover:not(.is-disabled)
            color $color-tertiary
            border-color #E1E1E1
            background-color $color-tertiary-text

    &.red
        color white
        // border-color alpha($color-red-1, 40%)
        background-color $color-red-1

    &.green
        color white
        // border-color alpha($color-green-5, 40%)
        background-color $color-green-5
        // basic-button-v2(1.0, 0.5, ".primary-button-bg")

    &.green-light
        color black
        border-color alpha($color-green-2, 25%)
        background-color alpha($color-green-1, 10%)
        // basic-button-v2(1.0, 0.5, ".primary-button-bg")

    &.reverse
        flex-direction row-reverse

        i
            font-size 12px
            font-weight normal

        *+i
            margin-left 0
            margin-right 16px

    &.icon-big

        i
            font-size 24px
            font-weight normal

            &+*
                margin-right 12px

    &.icon-medium

        i
            font-size 18px
            font-weight normal

            &+*
                margin-right 10px

    &.no-border
        border-width 0

    &.push-right
        margin-left auto !important

    &.push-left
        margin-right auto !important

    &.large-side-padding
        padding-left 24px
        padding-right 24px

    &:hover

        .hover-bounce
            animation hover-bounce-anim 0.75s infinite
            animation-timing-function ease-in-out

            @keyframes hover-bounce-anim
                0%
                    transform translateY(0px)
                50%
                    transform translateY(6px)
                100%
                    transform translateY(0px)

</style>



// WEBPACK FOOTER //
// src/components/v3/buttons/PrimaryButton.vue